export type StoreCardItemPromoType = 'stress' | 'itching' | 'mobility' | 'growth' | 'digestion';
export type StoreCardItemPromoSource =
  | 'breeders'
  | 'litters'
  | 'shelters'
  | 'articles'
  | 'breeds'
  | 'bookings';
export interface StoreCardItemPromoData {
  type: StoreCardItemPromoType;
  onClick: () => void;
  useMobileImage?: boolean;
}

export interface StoreCardItemPromoProps extends StoreCardItemPromoData {}
